export default __webpack_public_path__ + "static/media/c8517952-4ac9-4e0c-9c72-bc2c2522eb7a.e0e08760.jpg";